<script setup>
import { computed, ref, watch } from 'vue';
import { useAlert } from 'dashboard/composables';
import { parseAPIErrorResponse } from 'dashboard/store/utils/api';
import WahaSessionsAPI from 'dashboard/api/wahaSessions';
import Spinner from 'dashboard/components-next/spinner/Spinner.vue';
import WahaMessageSync from '../components/waha/WahaMessageSync.vue';

// WhatsApp history import of a WAHA inbox, in its own tab
const props = defineProps({
  inbox: {
    type: Object,
    required: true,
  },
});

const session = ref(null);
const isLoading = ref(true);

const sessionId = computed(() => props.inbox?.waha_session?.id);

const load = async () => {
  if (!sessionId.value) {
    isLoading.value = false;
    return;
  }
  try {
    const { data } = await WahaSessionsAPI.show(sessionId.value);
    session.value = data;
  } catch (error) {
    useAlert(parseAPIErrorResponse(error));
  } finally {
    isLoading.value = false;
  }
};

watch(sessionId, load, { immediate: true });
</script>

<template>
  <div v-if="isLoading" class="flex justify-center py-12">
    <Spinner />
  </div>

  <div v-else-if="session" class="flex flex-col gap-4 pb-8">
    <p
      v-if="session.status !== 'connected'"
      class="rounded-xl bg-n-amber-2 px-4 py-3 text-sm text-n-amber-11"
    >
      {{ $t('INBOX_MGMT.WAHA.APP.MESSAGE_SYNC.NOT_CONNECTED') }}
    </p>
    <WahaMessageSync :session="session" />
  </div>
</template>
